import {db} from "@/firebase/init";
import _ from "lodash";

export default {
    data() {
        return {
            activeSalesTaskListener: null,
            activeSalesTasks: [],
            resolvedSalesTasks: [],
        };
    },
    methods: {
        async fetchResolvedSalesTasks(){
            this.resolvedSalesTasks= []
            const ref = await db.collection('bigScootsTasks')
                .where('status', '==', 'resolved')
                .where('type', '==', 'sales')
                .orderBy("resolvedAt", "desc")
                .limit(500).get();
            if(ref.size){
                ref.forEach(el => {
                    this.resolvedSalesTasks.push({docId: el.id, ...el.data()})
                })
            }
            console.log('These resolved support tasks from mixin', this.resolvedSalesTasks )
        },
        async fetchActiveSalesTasksSnapShot(){
            this.activeSalesTasks = [];
            this.activeSalesTaskListener = null;
            const ref = await db.collection('bigScootsTasks')
                .where('status', '==', 'pending')
                .where('type', '==', 'sales')
                .orderBy("createdAt", "desc");
            this.activeSalesTaskListener = ref.onSnapshot(querySnapshot => {
                querySnapshot.docChanges().forEach(changeDoc => {
                    if (changeDoc.type === 'added'){
                        console.log('New Urgent Support Task Added from mixin');
                        const data = {docId: changeDoc.doc.id, ...changeDoc.doc.data()}
                        this.activeSalesTasks.push({...data})
                    } else if (changeDoc.type === 'modified') {
                        console.log('New Urgent Support Task Modified from mixin');
                        const data = {docId: changeDoc.doc.id, ...changeDoc.doc.data()}
                        let taskToUpdate = this.activeSalesTasks.find((task) => task.docId === data.docId );
                        const allKeys = Object.keys(data);
                        for (const key of allKeys){
                            taskToUpdate[key] = data[key];
                        }
                    } else if(changeDoc.type === 'removed') {
                        console.log('New Urgent Support Task Removed from mixin');
                        const data = {docId: changeDoc.doc.id, ...changeDoc.doc.data()}
                        this.activeSalesTasks = this.activeSalesTasks.filter(task => task.docId !== data.docId);
                    }
                });
            });
            console.log('These missing Cpanel support tasks from mixin', this.activeSalesTasks )
        },


    },
}
